export default __webpack_public_path__ + "static/2_26-a513417284ac9109995f65c57223fd91.png";